import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5379ae7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-link" }, [
  /*#__PURE__*/_createElementVNode("a", null, "Artyom Sklyarov")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "ext-icon back",
  viewBox: "0 0 24 24",
  width: "12",
  height: "12",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M19 12H5" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M12 19l-7-7 7-7" }, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "ext-icon",
  viewBox: "0 0 24 24",
  width: "12",
  height: "12",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M7 17 17 7" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M8 7h9v9" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import { computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const route = useRoute();
const link = computed(() => {
    if (route.path === '/posts') return { to: '/', label: 'home', back: true };
    if (route.path.startsWith('/posts/')) return { to: '/posts', label: 'all posts', back: true };
    return { to: '/posts', label: 'posts', back: false };
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    (_unref(link))
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: _unref(link).to,
          class: "blog-link"
        }, {
          default: _withCtx(() => [
            (_unref(link).back)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(_unref(link).label), 1),
            (!_unref(link).back)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true)
  ]))
}
}

})